import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from './services/queryClient';
import { useAuthContext } from './context/auth/useAuthContext';
import { router } from './router';

const App = () => {
  const auth = useAuthContext();

  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
        auth,
      }}
    />
  );
};

export default App;
